/**
 * @module cercaliagl/service/Service
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import { KEY } from '../globals';
import Servers from '../servers';
/**
 * @typedef {Object} ServiceOptions
 * @property {string} [url] Optional `url`. Default uses `Servers.servlet` value
 * @property {boolean} [concurrency] Optional. Default `true`. Multiple requests at same time. If `false` it cancel previous pending requests.
 */
/**
 * @typedef {Object} AjaxParams
 * @property {Object} [data] Parameters data.
 * @property {string} [url] URL.
 * @property {number} [timeout] Timeout in ms.
 * @property {function(*) : void} [callbackFn] Callback function.
 * @property {function(*) : void} [callbackFnError] Callback error function.
 */
var MAX_URL_LENGTH = 2000;
/**
 * @classdesc
 * @extends {CercaliaObject}
 */
var Service = /** @class */ (function () {
    /**
     * @constructor
     * @param {ServiceOptions} [options] Options
     */
    function Service(options) {
        if (options === void 0) { options = {}; }
        this.transport_ = axios.create({
            baseURL: options.url ? options.url : Servers.servlet,
            timeout: 3000, // Default timeout
        });
        /**
         * @private
         * @type {boolean}
         */
        this.concurrency_ = options.concurrency !== undefined ? options.concurrency : true;
        /**
         * @private
         * @param {CancelTokenSource}
         */
        this.ajaxRequest_ = null;
    }
    /**
     * HTTP Get Request
     * @param {AjaxParams} reqParams Params
     * @return {Promise}
     */
    Service.prototype.getRequest = function (reqParams) {
        if (!this.concurrency_) {
            if (this.ajaxRequest_) {
                this.ajaxRequest_.cancel();
            }
            this.ajaxRequest_ = axios.CancelToken.source();
        }
        var queryString = new URLSearchParams(reqParams.data).toString();
        var fullUrl = queryString ? "?".concat(queryString) : '';
        if (fullUrl.length > MAX_URL_LENGTH) {
            return this.postRequest(reqParams);
        }
        return this.transport_
            .get(this.baseUrl_, {
            params: __assign(__assign({}, reqParams.data), { key: KEY }),
            timeout: reqParams.timeout,
            cancelToken: !this.concurrency_ ? this.ajaxRequest_.token : undefined,
        })
            .then(function (response) {
            if (reqParams.callbackFn) {
                return reqParams.callbackFn(response.data);
            }
            return response.data;
        })
            .catch(function (error) {
            if (!axios.isCancel(error)) {
                if (reqParams.callbackFnError) {
                    reqParams.callbackFnError(error);
                }
                else {
                    console.error(error); // eslint-disable-line no-console
                }
            }
        });
    };
    /**
     * HTTP Post Request
     * @param {AjaxParams} reqParams Params
     * @return {Promise}
     */
    Service.prototype.postRequest = function (reqParams) {
        var postParams = __assign(__assign({}, reqParams.data), { key: KEY, timeout: reqParams.timeout });
        var queryString = new URLSearchParams(postParams);
        return this.transport_
            .post(this.baseUrl_, queryString, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
            .then(function (response) {
            if (reqParams.callbackFn) {
                return reqParams.callbackFn(response.data);
            }
            return response.data;
        })
            .catch(function (error) {
            if (reqParams.callbackFnError) {
                reqParams.callbackFnError(error);
            }
            else {
                console.error(error); // eslint-disable-line no-console
            }
        });
    };
    return Service;
}());
export default Service;
//# sourceMappingURL=Service.js.map